// Lib
import { first, last, split } from 'lodash/fp';

// Utils
import stripFileExtension from '../../../../common/files/stripFileExtension';
import randomString from '../../../../common/uid/randomString';

const splitSlash = split('/');
const splitQuery = split('?');

export const getFilenameFromUrl = (url: string, fileType: string): string => {
    const lastPart = (last(splitSlash(url)) as string) ?? '';
    const filename = (first(splitQuery(lastPart)) as string) ?? '';

    if (filename.indexOf('.') > -1) return filename;

    const extension = (last(splitSlash(fileType)) as string) ?? '';
    return `${filename}.${extension}`;
};

export const appendToFilename = (filename: string) => {
    const [base = '', ...rest] = filename.split('.');

    return [`${base}-${randomString(6)}`, ...rest].join('.');
};

/**
 * Replace or append an extension on a filename.
 */
export const replaceFileExtension = (filename: string, extension: string): string => {
    const normalizedExtension = extension.replace(/^\./, '');
    return `${stripFileExtension(filename)}.${normalizedExtension}`;
};

type UploadFileBlob = Blob & { name: string; lastModified: number };

/**
 * Attach upload metadata expected by the image upload pipeline.
 */
export const enrichBlobAsUploadFile = (blob: Blob, filename: string): UploadFileBlob =>
    Object.assign(blob, {
        name: filename,
        lastModified: Date.now(),
    }) as UploadFileBlob;
